import { render, staticRenderFns } from "./NutritionLabels.vue?vue&type=template&id=606e656b&"
import script from "./NutritionLabels.vue?vue&type=script&lang=js&"
export * from "./NutritionLabels.vue?vue&type=script&lang=js&"
import style0 from "./NutritionLabels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports